import { ProductType } from '@/data/types/Product';
import {
	createContext,
	Dispatch,
	SetStateAction,
	useContext,
	useMemo,
	useState,
} from 'react';

export type PDPContextType = {
	product: ProductType | undefined;
	setProduct: Dispatch<SetStateAction<ProductType | undefined>>;
};

export const PDPContext = createContext<PDPContextType>({} as PDPContextType);

export const PDPProvider = ({ children }: { children: React.ReactNode }) => {
	const [product, setProduct] = useState<ProductType | undefined>(undefined);

	const value = useMemo(() => ({ product, setProduct }), [product]);

	return <PDPContext.Provider value={value}>{children}</PDPContext.Provider>;
};

export const usePDPContext = () => {
	const context = useContext(PDPContext);

	if (!context) {
		throw new Error('usePDPContext must be used within a PDPProvider');
	}

	return context;
};
